import { createProductsSlice } from 'shared-redux/state'
import { defaultAppConfig } from '#/src/appConfig'

const defaultSorting = defaultAppConfig.config.sortingOptions.find((o) => o.default)

const customProductSlice = createProductsSlice({
  initialState: {
    priceRangeFilter: defaultAppConfig.config.sliderDefaultValues,
    ...(defaultSorting
      ? {
          sortBy: defaultSorting.sortBy,
          sortOrder: defaultSorting.sortOrder,
          sortLabel: defaultSorting.sortLabel
        }
      : {})
  }
})

export default customProductSlice.reducer
